import { render, staticRenderFns } from "./CartPopupBlock.vue?vue&type=template&id=21ae6c61&scoped=true&"
import script from "./CartPopupBlock.vue?vue&type=script&lang=js&"
export * from "./CartPopupBlock.vue?vue&type=script&lang=js&"
import style0 from "./CartPopupBlock.vue?vue&type=style&index=0&id=21ae6c61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ae6c61",
  null
  
)

export default component.exports